
import { defineComponent, ref, computed } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router"; 
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";

export default defineComponent({
  name: "sign-in",
  components: {},
  setup() {
    const store = useStore();
    const router = useRouter();
    const email = ref("");
    const password = ref("");
    const acceptedTerms = ref(false);
    const toastMessage = ref("");
    const toastType = ref("");
    const showToastFlag = ref(false);
    const submitButton = ref<HTMLElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      email: Yup.string().required().label("UserName"),
      password: Yup.string().min(4).required().label("Password"),
      toc: Yup.boolean().required(),
    });

    //Form submit function
    const showToast = (msg, type) => {
        toastMessage.value = msg;
        toastType.value = type;
        showToastFlag.value = true;

        setTimeout(() => {
            showToastFlag.value = false;
        }, 4000);
    };

    const isFormValid = computed(() => {
      return (
        email.value.trim() !== "" &&
        password.value.trim() !== "" &&
        acceptedTerms.value
      );
    });

    const onSubmitLogin = (values) => {
      const elemail: HTMLInputElement | null =
        document.querySelector("#txtUserName");
      const elpassword: HTMLInputElement | null =
        document.querySelector("#txtUserPassword");
      const chkTerms = document.querySelector("#chkTerms") as HTMLInputElement;
      // Check terms and conditions
      if (!chkTerms.checked) {
        showToast("Please accept the Terms and Conditions to continue.", "error");
        return;
      }

      let val = {
        email: email.value,
        password: password.value,
      };
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      // if (val) {
      //   // Activate indicator
      //  val.setAttribute("data-kt-indicator", "on");
      // }

      // Dummy delay
      setTimeout(() => {
        // Send login request
        store
          .dispatch(Actions.LOGIN, val)
          //.then(() => {
          //  Swal.fire({
          //    text: "All is cool! Now you submit this form",
          //    icon: "success",
          //    buttonsStyling: false,
          //    confirmButtonText: "Ok, got it!",
          //    customClass: {
          //      confirmButton: "btn fw-bold btn-light-primary",
          //    },
          //  }).then(function () {
          // Go to page after successfully login
          //    router.push({ name: "dashboard" });
          //  });
          //})
          .then(function () {
            router.push({ name: "GasPrices" });
          })
          .catch(() => {
            Swal.fire({
              text: store.getters.getErrors[0],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });

        //Deactivate indicator
        submitButton.value?.removeAttribute("data-kt-indicator");
      }, 2000);
    };

    return {
      onSubmitLogin,
      email,
      password,
      acceptedTerms,
      login,
      submitButton,
      showToastFlag,
      toastMessage,
      toastType,
      isFormValid,
    };
  },
});
